.invite-member {
  display: flex;
  flex-direction: row;
  gap: 1.6rem;
  align-items: center;
}

.container {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}
